<template>
  <Base>
    <Toast/>

    <template v-slot:contentBase>

      <!-- ======================= ROW 1 ======================= -->
      <div class="row">

        <!-- COL 1: CONSTRUÇÕES PROGRESSO (col-md-6) -->
        <div class="col-md-6" v-if="dados.lista_progresso?.length">
          <div class="ibox" style="background-color: darkred">
            <div class="ibox-title">
              <h5>Construções</h5>
            </div>

            <div class="ibox-content">

              <div v-for="item in dados.lista_progresso" :key="item.id">

                <div>
                  <strong>{{ item.construcao }}</strong>
                  <span class="pull-right">
                    <strong>Previsão Orçamentária: R$ {{ item.previsao_orcamentaria }}</strong>
                  </span>
                </div>

                <br>

                <span><strong>ESTIMATIVA DE TEMPO</strong></span>
                <strong>( {{ item.tempo_construcao }} / {{ item.tempo_max }} )</strong>
                <strong>{{ item.progresso }}%</strong>

                <div class="pull-right">
                  <strong>Início: {{ item.data_inicio }}</strong>
                  <strong>| Previsão: {{ item.data_previsao_termino }}</strong>
                </div>

                <!-- PROGRESSO -->
                <div class="progress mb-3">
                  <div class="progress-bar progress-bar-striped progress-bar-animated"
                       :class="item.cor_barra"
                       :style="`width: ${item.progresso}%`">
                  </div>
                </div>

                <!-- ORÇAMENTO ATUAL -->
                <div v-if="item.porcentagem_orcamento_final >= 70">
                  <span><strong>ORÇAMENTO ATUAL:</strong></span>
                  <strong>{{ item.porcentagem_orcamento_final }}%</strong>

                  <div class="pull-right">
                    <strong>Valor: R$ {{ item.orcamento_final }}</strong>
                  </div>

                  <div class="progress">
                    <div class="progress-bar progress-bar-striped progress-bar-animated"
                         :class="item.porcentagem_orcamento_final >= 100 ? 'progress-bar-danger' : 'progress-bar-success'"
                         :style="`width: ${item.porcentagem_orcamento_final}%`">
                    </div>
                  </div>
                </div>

                <hr>

              </div>

            </div>
          </div>
        </div>
        <!-- MAPA + STATUS -->
        <div class="col-md-6">

          <div class="ibox">
            <div class="ibox-title">
              <h5>Mapa de Imóveis</h5>
            </div>

            <div class="ibox-content">
              <div class="row">

                <!-- MAPA -->
                <div class="col-md-9">
                  <BaseMapa :imoveis="imoveisComLocalizacao"/>
                </div>

                <!-- STATUS LATERAL -->
                <div class="col-md-3">

                  <div class="card text-white bg-success mb-2">
                    <div class="card-body p-2">
                      <div>Disponíveis</div>
                      <h3>{{ dados.imoveis_status?.D?.total || 0 }}</h3>
                    </div>
                  </div>

                  <div class="card text-white bg-warning mb-2">
                    <div class="card-body p-2">
                      <div>Em Análise</div>
                      <h3>{{ dados.imoveis_status?.E?.total || 0 }}</h3>
                    </div>
                  </div>

                  <div class="card text-white bg-primary mb-2">
                    <div class="card-body p-2">
                      <div>Vendidos</div>
                      <h3>{{ dados.imoveis_status?.A?.total || 0 }}</h3>
                      <small>Últimos 60 dias</small>
                    </div>
                  </div>

                </div>

              </div>
            </div>
          </div>

        </div>
        <!-- END MAPA -->
        <!-- END CONSTRUÇÕES -->

      </div>
      <!-- ======================= END ROW 1 ======================= -->


      <!-- ======================= ROW 2 ======================= -->
      <div class="row mt-3">

        <!--        &lt;!&ndash; COL 3: DOUGHNUT  &ndash;&gt;-->
        <div class="col-md-6" >
<!--          <div class="ibox" v-if="mostrarDoughnut">-->
<!--            <div class="ibox-title">-->
<!--              <h5>Análises aprovados<br>(60 dias)</h5>-->
<!--            </div>-->

<!--            <div class="ibox-content">-->
<!--              <Chart-->
<!--                  type="doughnut"-->
<!--                  :data="chartData"-->
<!--                  :options="chartOptions"-->
<!--              />-->
<!--            </div>-->
<!--          </div>-->
        </div>
<!--        &lt;!&ndash; END DOUGHNUT &ndash;&gt;-->

        <!-- COL 2: CHAMADOS -->
        <div class="col-md-6">
          <div class="ibox" v-if="dados.chamados_crm?.length">
            <div class="ibox-title">
              <h5>Últimos chamados em aberto - CRM</h5>
            </div>

            <div class="ibox-content">

              <table class="footable table table-hover">
                <thead>
                <tr>
                  <th>ID</th>
                  <th>CLIENTE</th>
                  <th>IMÓVEL</th>
                  <th>DATA</th>
                  <th>DESCRIÇÃO</th>
                  <th>STATUS</th>
                  <th data-hide="all">DANOS</th>
                  <th data-hide="all">ITEM</th>
                  <th data-hide="all">ELEMENTO</th>
                  <th data-hide="all">PATOLOGIA</th>
                  <th data-hide="all">PRAZO</th>
                  <th>MAIS</th>
                </tr>
                </thead>

                <tbody>
                <tr v-for="chamado in dados.chamados_crm" :key="chamado.id">
                  <td>{{ chamado.id }}</td>
                  <td>{{ chamado.cliente }}</td>
                  <td>{{ chamado.imovel }}</td>
                  <td>{{ chamado.data_cadastro }}</td>
                  <td>{{ chamado.descricao }}</td>
                  <td v-html="chamado.status"></td>
                  <td>{{ chamado.tipo_dano }}</td>
                  <td>{{ chamado.item }}</td>
                  <td>{{ chamado.elemento }}</td>
                  <td>{{ chamado.patologia }}</td>
                  <td>{{ chamado.prazo }}</td>
                  <td class="text-center" @click="crmList(chamado.id, chamado.key)">
                    <i class="fa fa-mail-forward"></i>
                  </td>
                </tr>
                </tbody>

              </table>

            </div>
          </div>
        </div>
        <!-- END CHAMADOS -->

      </div>
      <!-- ======================= END ROW 2 ======================= -->

    </template>
  </Base>
</template>

<script>
import Base from '@/components/base/Base.vue';
import BaseMapa from "@/components/base/BaseMapa.vue";
import {apiRequest} from "../../public/js/utils/funcoes";
import Chart from 'primevue/chart';
import Tooltip from 'primevue/tooltip';


export default {
  name: 'HomeView',
  components: {
    Base,
    BaseMapa,
    Chart,
  },
  directives: {tooltip: Tooltip},
  data() {
    return {
      dados: [],
      imoveisComLocalizacao: [],
      chartData: {},
      chartOptions: {}
    }
  },
  methods: {
    async getDados() {
      const resultado = await apiRequest("GET", `${process.env.VUE_APP_API_URL}`);
      if (resultado.success) {
        this.dados = resultado.data;

        if (this.dados.imoveis_lista) {
          this.imoveisComLocalizacao = this.dados.imoveis_lista;
        }

        await this.$nextTick(() => {
          this.graficoAnalises();

          const table = $('.footable');
          if (table.data('footable')) {
            table.data('footable').destroy();
          }

          // Re-inicializa a tabela
          $('.footable').footable();
        })
      } else {
        this.$toastMessage("warn", "Atenção", "Erro ao carregar registro!");
        console.error("Erro ao carregar:", resultado.error);
      }
    },
    graficoAnalises() {
      const status = this.dados.imoveis_status;
      if (status) {
        this.chartData = {
          labels: ["Aprovados", "Disponíveis", "Em análise", "Reprovados", "Aguardando Assinatura"],
          datasets: [{
            data: [
              status.A?.total || 0,
              status.D?.total || 0,
              status.E?.total || 0,
              status.R?.total || 0,
              status.EM?.total || 0
            ],
            backgroundColor: ["#18a689", "#1C84C6", "#f8ac59", "#ed5565", "#9E9E9E"]
          }]
        };

        this.chartOptions = {
          responsive: true,
          plugins: {
            legend: {
              position: "bottom",
              labels: {
                color: "#495057"
              }
            }
          }
        };
      }
    },

    crmList(id_chamado, key_chamado) {
      this.$router.push({path: '/crm/solicitacoes', query: {abrir: 'tabs', id: id_chamado, key: key_chamado}});
    }
  },
  mounted() {
    this.getDados();
  },
  computed: {
    mostrarDoughnut() {
      const status = this.dados.imoveis_status;
      if (!status) return false;
      return Object.values(status).some(item => item.total > 0);
    }
  }
}
</script>
